import { Trans, useTranslation } from 'react-i18next';
import ManageLanguagesButton from 'pages/automations/common/manageLanguages/ManageLanguagesButton';
import { UsageType } from 'models/automation/Common';
import { SystemTemplatesHeaderStyled } from '../SystemTemplatesTab.styles';
import SystemTemplatesTabGlobalToggle from './SystemTemplatesTabGlobalToggle';

const SystemTemplatesTabHeader = () => {
  const { t } = useTranslation();

  return (
    <SystemTemplatesHeaderStyled
      title={t('pageAutomations.systemTemplates.title')}
      subtitle={
        <Trans
          i18nKey="pageAutomations.systemTemplates.subtitle"
          components={{
            link1: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/2434707-understand-system-templates"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      noDivider
      buttons={
        <ManageLanguagesButton
          usageType={UsageType.SYSTEM}
          hideAutoTranslation
        />
      }
    >
      <SystemTemplatesTabGlobalToggle />
    </SystemTemplatesHeaderStyled>
  );
};

export default SystemTemplatesTabHeader;
